import groq from 'groq';

export const BLOG_CAROUSEL = groq`
  _type,
  title,
  category,
  ctaLabel
`;

export const BLOG_CAROUSEL_BLOCK = groq`
  _type == 'blogCarousel' => @-> {
    ${BLOG_CAROUSEL}
  }
`;
